import React, { useCallback, useContext, useMemo, useState } from 'react'
import { Button, Field, Input, VStack } from '@chakra-ui/react'
import { Page } from './components/page'
import { CommunicatorContext } from './communication/communicator-context'
import { Proto } from '@probe/shared'
import _ from 'lodash'
import { NotificationContext } from './main/components/notifications'
import moment from 'moment-timezone'
import { DateChooser } from './main/components/date-chooser'

export const Download = () => {
    const [probeId, setProbeId] = useState('')
    const [fromDate, setFromDate] = useState<Date>(moment().subtract(7, 'days').toDate())
    const [toDate, setToDate] = useState<Date>(moment().toDate())
    const communicator = useContext(CommunicatorContext)
    const notification = useContext(NotificationContext)

    const canDownload = probeId.trim().length > 0 && fromDate && toDate

    const handleDownload = useCallback(async () => {
        if (!canDownload) {
            return
        }

        try {
            const response = await communicator.doRequest(
                new Proto.Download.CreateDownloadTokenRequest(
                    probeId,
                    moment(fromDate).startOf('day').toDate(),
                    moment(toDate).endOf('day').toDate()
                )
            )
            if (response instanceof Proto.Download.CreateDownloadTokenRespone) {
                if (response.count > 0) {
                    window.location.href = `/api/casts/download?token=${response.token}`
                } else {
                    throw new Error(`No data for probe`)
                }
            }
        } catch (e) {
            notification.setNotification({
                type: 'error',
                message: (e as Error).message
            })
        }
    }, [probeId, fromDate, toDate])

    return (
        <Page title="Download Probe Data">
            <VStack align="stretch" gap={4} maxW="md">
                <Field.Root>
                    <Field.Label>Probe Id</Field.Label>
                    <Input
                        value={probeId}
                        onChange={(e) => setProbeId(e.target.value)}
                        placeholder="Probe id"
                    />
                </Field.Root>

                <Field.Root maxW="fit-content">
                    <Field.Label>Start date</Field.Label>
                    <DateChooser value={fromDate} setDate={setFromDate} />
                </Field.Root>

                <Field.Root maxW="fit-content">
                    <Field.Label>End date</Field.Label>
                    <DateChooser value={toDate} setDate={setToDate} />
                </Field.Root>

                <Button
                    colorPalette="blue"
                    alignSelf="flex-start"
                    onClick={handleDownload}
                    disabled={!canDownload}
                >
                    Download
                </Button>
            </VStack>
        </Page>
    )
}
